import { useMutation } from '@tanstack/react-query'
import {
  createPublicAppointment,
  type PublicAppointmentPayload,
} from '@/services/httpServices/appointmentService'

/** Books a public (website) appointment. */
export function useCreatePublicAppointment() {
  return useMutation({
    mutationFn: (payload: PublicAppointmentPayload) => createPublicAppointment(payload),
  })
}
